export default {
    apiKey: 'AIzaSyClFE1K9xsErM6RDCVM7LRnYFQIkndpJDw',
    authDomain: 'teamapp-63a91.firebaseapp.com',
    databaseURL: 'https://teamapp-63a91.firebaseio.com',
    projectId: 'teamapp-63a91',
    storageBucket: 'gs://teamapp-63a91.appspot.com',
 }


//////////////////
// WEBPACK FOOTER
// ./config/firebaseConfig.js
// module id = null
// module chunks = 